import TaskBaseService from 'services/task/TaskBaseService';

export default class QuestionTaskService extends TaskBaseService {}
